import {withStyles} from "@material-ui/styles";
import Dialog from "@material-ui/core/Dialog";

export const DialogWithoutBackdropColor = withStyles(() => ({
    root: {
        '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0,0,0,0)'
        }
    },
    paper: {
        height: 'calc(100% - 64px)'
    }
}))(Dialog)